import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AccountStoreService } from '../../../services/storage/account-store.service';

@Component({
    selector: 'app-application-layout',
    templateUrl: './application-layout.component.html',
    styleUrls: ['./application-layout.component.scss'],
    standalone: false
})
export class ApplicationLayoutComponent implements OnInit {

  constructor(
    accountStoreService: AccountStoreService,
    route: ActivatedRoute) {
    if (route.snapshot.params.accountId !== undefined) { // is undefined on imprint state because the user might not logged in yet
      accountStoreService.setAccountById(route.snapshot.params.accountId);
    }
  }

  ngOnInit() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    // Update the inner height for mobile browsers on navigation hide and show
    window.addEventListener('resize', () => {
      vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
  }
}
